// Module
var code = `<span class="hidden md:block">{{label}}</span>
{{svgPlus}}
`;
// Exports
module.exports = code;